var chunkMapping = {
	"150": [
		20150
	],
	"691": [
		60691
	],
	"859": [
		20859
	],
	"889": [
		60889
	],
	"928": [
		38459
	],
	"1116": [
		51116
	],
	"1170": [
		51170
	],
	"1665": [
		31665
	],
	"2349": [
		42349
	],
	"3022": [
		33022
	],
	"4217": [
		24217
	],
	"4316": [
		54316
	],
	"4966": [
		54966
	],
	"5288": [
		75288
	],
	"5767": [
		85767
	],
	"7432": [
		77432
	],
	"8149": [
		38149
	],
	"9077": [
		69077
	],
	"9148": [
		19148
	],
	"9280": [
		83975
	],
	"9528": [
		99528
	],
	"9602": [
		6320,
		16460,
		20483,
		21504,
		24505,
		33499,
		35514,
		37197,
		39759,
		41479,
		42970,
		58601,
		59441,
		60353,
		61066,
		63989,
		64101,
		72724,
		73009,
		82052,
		89923,
		90026,
		93847,
		94881
	],
	"9792": [
		99792
	],
	"9997": [
		50948
	]
};
var idToExternalAndNameMapping = {
	"6320": [
		"default",
		"./pages/OnlineStore/GoFood/Outlets/Outlets",
		46291
	],
	"16460": [
		"default",
		"./routes/customers",
		17658
	],
	"19148": [
		"default",
		"./sagas",
		46291
	],
	"20150": [
		"default",
		"./version",
		56836
	],
	"20483": [
		"default",
		"./pages/OnlineStore/OnlineStore",
		46291
	],
	"20859": [
		"default",
		"./sagas",
		15265
	],
	"21504": [
		"default",
		"./pages/OnlineStore/GoFood/ManageOnlineMenu/Categories",
		46291
	],
	"24217": [
		"default",
		"./libs/react-dom",
		40260
	],
	"24505": [
		"default",
		"./routes/customers/list",
		17658
	],
	"31665": [
		"default",
		"./sagas",
		56836
	],
	"33022": [
		"default",
		"./sagas",
		26225
	],
	"33499": [
		"default",
		"./routes/customers/loyalty",
		17658
	],
	"35514": [
		"default",
		"./pages/OnlineStore/FacebookShop/FacebookShop",
		46291
	],
	"37197": [
		"default",
		"./pages/ingredient/recipes",
		26225
	],
	"38149": [
		"default",
		"./reducers",
		46291
	],
	"38459": [
		"default",
		"./reducers",
		15265
	],
	"39759": [
		"default",
		"./pages/OnlineStore/GoFood/ManageOnlineMenu/ItemsSort",
		46291
	],
	"41479": [
		"default",
		"./pages/OnlineStore/GoFood/ManageOnlineMenu/Items",
		46291
	],
	"42349": [
		"default",
		"./reducers",
		56836
	],
	"42970": [
		"default",
		"./pages/OnlineStore/GoFood/ManageOnlineMenu/CategoriesSort",
		46291
	],
	"50948": [
		"default",
		"./sagas",
		17658
	],
	"51116": [
		"default",
		"./version",
		47004
	],
	"51170": [
		"default",
		"./version",
		46291
	],
	"54316": [
		"default",
		"./reducers",
		26225
	],
	"54966": [
		"default",
		"./pages/PurchaseOrder/PurchaseOrder",
		40260
	],
	"58601": [
		"default",
		"./pages/PaymentMethod",
		56836
	],
	"59441": [
		"default",
		"./routes/table-management",
		15265
	],
	"60353": [
		"default",
		"./pages/PaymentConfiguration",
		56836
	],
	"60691": [
		"default",
		"./version",
		40260
	],
	"60889": [
		"default",
		"./version",
		26225
	],
	"61066": [
		"default",
		"./routes/table-management/map",
		15265
	],
	"63989": [
		"default",
		"./pages/ingredient/list",
		26225
	],
	"64101": [
		"default",
		"./pages/ingredient/categories",
		26225
	],
	"69077": [
		"default",
		"./reducers",
		17658
	],
	"72724": [
		"default",
		"./pages/OnlineStore/GoStore/GoStore",
		46291
	],
	"73009": [
		"default",
		"./routes/table-management/report",
		15265
	],
	"75288": [
		"default",
		"./setup",
		46291
	],
	"77432": [
		"default",
		"./setup",
		40260
	],
	"82052": [
		"default",
		"./pages/ingredient",
		26225
	],
	"83975": [
		"default",
		"./lib/clickstream",
		51907
	],
	"85767": [
		"default",
		"./version",
		76404
	],
	"89923": [
		"default",
		"./routes/table-management/void-item-report",
		15265
	],
	"90026": [
		"default",
		"./routes/table-management/group",
		15265
	],
	"93847": [
		"default",
		"./routes/customers/feedback_list",
		17658
	],
	"94881": [
		"default",
		"./pages/OnlineStore/Google/Google",
		46291
	],
	"99528": [
		"default",
		"./version",
		17658
	],
	"99792": [
		"default",
		"./setup",
		17658
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}